import React, {useMemo} from 'react';
import {ConfirmationDialog} from 'shared/components/ConfirmationDialog/ConfirmationDialog';
import {useNavigationBlocker} from 'shared/components/ConfirmationDialog/useNavigationBlocker';

type NavigatorConfirmationDialogType = {
    showConfirmation: boolean;
    onClick: () => void;
    onCancel?: () => void;
    title?: string;
    message?: string;
    confirmBtnText?: string;
    cancelBtnText?: string;
};

export const NavigatorConfirmationDialog = ({
    showConfirmation,
    onClick,
    onCancel,
    confirmBtnText = 'Proceed',
    cancelBtnText = 'Cancel',
    ...props
}: NavigatorConfirmationDialogType) => {
    const {isBlocked, confirmNavigation, cancelNavigation} =
        useNavigationBlocker(showConfirmation);

    const options = useMemo(
        () => ({
            hideYesButton: true,
            hideNoButton: true,
            buttons: [
                {
                    name: confirmBtnText,
                    show: true,
                    variant: 'danger',
                    action: () => {
                        confirmNavigation();
                        onClick && onClick();
                    },
                },
                {
                    name: cancelBtnText,
                    show: true,
                    action: () => {
                        onCancel && onCancel();
                    },
                },
            ],
        }),
        [onClick, onCancel, confirmNavigation, confirmBtnText, cancelBtnText]
    );

    return (
        <ConfirmationDialog
            {...props}
            show={isBlocked}
            options={options}
            hideDialog={cancelNavigation}
            backdrop="static"
        />
    );
};
